import React from "react";
import Link from "next/link";

const FreeCourseScheduleSection = ({ schedule }) => {

    return (
        <div className="w-full relative p-5 bg-accent-100 rounded-xl mt-16">
            <div className="absolute w-[150px] sm:w-[280px]" >
                <svg className="w-[150px] sm:w-[280px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 3 51 19">
                    <path d="M 0 3 L 0 22 C 0 21 1 21 2 21 L 30 21 C 31 21 33 21 35 19 C 40 14 45 3 51 3 L 0 3" fill="#0D9488" />
                </svg>
                <div className="absolute left-2 top-0 md:left-6 md:top-3">
                    <h3 className="text-white text-md font-body font-bold mb-1 tracking-wide sm:text-2xl">Mulai Program</h3>
                </div>
            </div>
            <div className="flex w-full pt-12 sm:pt-28 pb-16 pl-5 pr-2 md:px-14 h-full bg-secondary-100 rounded-xl">
                <div className="flex w-5/12 absolute right-8 md:right-16 top-7 md:top-16 sm:top-12 sm: justify-end">
                    <p className="text-white text-[12px] sm:text-sm md:text-md xl:text-xl text-right font-body font-normal leading-tight">Jadwal program yang dapat diikuti</p>
                </div>
                <div className="flex w-full pt-10 flex-col">
                    <div id="program-schedule-free-course" className="flex flex-col w-full">
                        {schedule.map((courseSchedule) => (
                            <div key={courseSchedule.id} className='flex items-center justify-between pl-0 sm:pl-1 pr-2 mt-5 mb-5'>
                                <div className='basis-1/4 text-md md:text-md md:text-3xl text-white font-body font-bold tracking-wide flex'>
                                    {courseSchedule.date}
                                    <div className='border-2 mx-1 md:mx-2 border-accent-100'></div>
                                    <h3 className='basis-1/4 text-xs md:text-md md:text-xl text-white font-body font-bold tracking-wide flex'>{courseSchedule.programTitle}</h3>
                                </div>
                                <div className='shrink justify-center items-center'>
                                    <h4 className='text-xs md:text-md md:text-xl text-white font-body font-bold tracking-wide text-center pl-2 md:pl-0'>{courseSchedule.day}</h4>
                                    <div className='w-full md:w-fit bg-main-100 rounded-full px-2 py-1 m-1 md:mt-0 md:px-2 md:py-2'>
                                        <p className='text-secondary-100 text-[8.5px] md:text-sm font-body font-bold'>{courseSchedule.time}</p>
                                    </div>
                                </div>
                                <Link href="/courses/register" className="hover:bg-white hover:text-accent-100 shrink ml-4 text-sm sm:text-base font-medium font-body text-white bg-accent-100 py-2 px-4 sm:px-8 sm:py-3 rounded transition duration-300 ease-out">
                                    Daftar
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default FreeCourseScheduleSection;             
